require('./brokerETFBuyStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @helpers
const {
    FIRST_STEP,
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER,
    BROKER_ETF_BUY_BUYFOR_TITLES,
    BROKER_ETF_BUY_BUYFOR_AMOUNT,
    BROKER_ETF_BUY_STEP1_MAX_TITLE_DIGITS,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ETF_BUY_STEP1_MAX_IMPORT_DIGITS,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    MAX_FRACTION_LENGTH_IN_STORE_LIMITED
} = require('constants/index');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const { ETFS_BUY_CODE } = require('constants/operationCodesAccounts');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');

// @commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');
const { AmountInput } = require('commonsComponents/amountInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerHolidayErrorModal = require('components/broker/commons/brokerHolidayErrorModal/brokerHolidayErrorModal');

// @ actions
const BrokerETFBuyActions = require('actions/brokerETFBuy');
const BlockedAccounts = require('actions/blockedAccounts');

class BrokerETFBuyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleBuyForRadiosChange = this.handleBuyForRadiosChange.bind(this);
        this.handleBuyForInputChange = this.handleBuyForInputChange.bind(this);
        this.handleOrderTypeRadiosChange = this.handleOrderTypeRadiosChange.bind(this);
        this.handleOrderTypeInputChange = this.handleOrderTypeInputChange.bind(this);
        this.onHandleDateChange = this.onHandleDateChange.bind(this);
        this.buildForTheBestRadioButton = this.buildForTheBestRadioButton.bind(this);
        this.validateProductPrice = this.validateProductPrice.bind(this);
        this.handleBuyForInputAmountChange = this.handleBuyForInputAmountChange.bind(this);
        this.handleHolidayModalErrorOpen = this.handleHolidayModalErrorOpen.bind(this);
    }

    componentDidMount(){
        const { getBlockedAccounts, immAccounts } = this.props;

        getBlockedAccounts(immAccounts.get("byId").toList(),ETFS_BUY_CODE);
    }

    onHandleDateChange(date) {
        this.props.validityDateChanged(date);
    }

    buildForTheBestRadioButton() {
        const { productIso } = this.props;

        // Get the two first letter from ISIN to know if it is a spanish market
        if (productIso === SPANISH_CONTINUES_MARKET_ISO_CODE) {
            return (
                <RadioButton
                    key="etf-buy-step1__radio-button__for-the-best"
                    label={formatText('broker-etfBuyStep1ForTheBestLabel')}
                    value={BROKER_ORDER_TYPE_FOR_THE_BEST}
                    className="etf-buy-step1__radio-button"
                />
            );
        }
    }

    buildRadioButtons() {
        const { productCurrency } = this.props;
        const forTheBestRadioButton = this.buildForTheBestRadioButton();

        const marketRadioButton = (
            <RadioButton
                key="etf-buy-step1__radio-button__to-market"
                label={formatText('broker-stocksBuyStep1ToMarketLabel')}
                value="toMarket"
                className="stocks-buy-step1__radio-button"
            />
        );

        const limitedRadioButton = (
            <RadioButton
                key="etf-buy-step1__radio-button__limited"
                label={`${formatText('broker-stocksBuyStep1LimitedLabel')} (${productCurrency})`}
                value="limited"
                className="stocks-buy-step1__radio-button"
            />
        );

        const radioButtons = [marketRadioButton, forTheBestRadioButton, limitedRadioButton];

        return radioButtons.filter(value => value !== undefined);
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContracts } = this.props;

        const processedStocksContract = immStocksContracts.map((entry, index) => {
            const associatedAccountBalance = {
                amount: entry.getIn(['associatedAccountBalance', 'amount']),
                currency: entry.getIn(['associatedAccountBalance', 'currency'])
            };

            return entry.merge({
                value: index,
                walletBalance: associatedAccountBalance
            });
        });

        return processedStocksContract.toJS();
    }

    handleBuyForInputAmountChange(value) {
        const { productPrice } = this.props;
        const newValue = parseFloat(value);
        const titleQuantity = Math.floor(newValue / productPrice);
        this.props.buyForValueChanged(newValue, titleQuantity, productPrice);
    }

    handleBuyForInputChange(event) {
        const nextValue = nonNumericFilter(event.target.value);

        if (event.target.value.length < BROKER_ETF_BUY_STEP1_MAX_TITLE_DIGITS) {
            this.props.buyForValueChanged(nextValue);
        }
    }

    handleBuyForRadiosChange(value) {
        const { buyForOptionChanged, buyForValueReset, immBrokerETFBuy, productPrice } = this.props;

        const buyForDefaultPrice = immBrokerETFBuy.getIn(['steps', FIRST_STEP, 'buyForValue']);
        const initialPrice = this.validateProductPrice(buyForDefaultPrice, productPrice);

        buyForOptionChanged(value);
        buyForValueReset('', initialPrice);
    }

    handleHolidayModalErrorOpen() {
        this.props.setHolidayError();
    }

    handleOrderTypeInputChange(value) {
        if (('' + value).length < BROKER_ETF_BUY_STEP1_MAX_IMPORT_DIGITS) {
            this.props.orderTypeValueChanged(parseFloat(value));
        }
    }

    handleOrderTypeRadiosChange(value) {
        const { orderTypeOptionChanged, orderTypeValueReset, productPrice } = this.props;

        orderTypeOptionChanged(value);
        orderTypeValueReset(parseFloat(productPrice));
    }

    validateProductPrice(inputPrice, productPrice) {
        let roundedPrice = productPrice;
        if (productPrice) {
            roundedPrice = parseFloat(productPrice);
        }

        return roundedPrice;
    }

    buildLegalSection() {
        return (
            <ContactCenterRender>
                <section className="etf-buy-step1__group-div">
                    <BlockInfo>{ formatText('broker-etfBuyStep1LegalText') }</BlockInfo>
                </section>
            </ContactCenterRender>
        );
    }

    render() {
        const { immBrokerETFBuy, stockContractChanged, immAccounts, immStocksContracts } = this.props;
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const step1 = immBrokerETFBuy.get('steps').get(FIRST_STEP);
        const stocksContractSelectedValue = step1.get('stocksContractSelectedValue');
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const buyForOption = step1.get('buyForOption');
        const buyForValue = step1.get('buyForValue');
        const orderTypeOption = step1.get('orderTypeOption');
        const orderTypeValue = step1.get('orderTypeValue');
        const firstDate = step1.get('firstDate');
        const limitDate = step1.get('limitDate');
        const validityDate = step1.get('validityDate');
        const errorFlags = step1.get('errorFlags');
        const buyForAmountLabel = `${formatText('broker-etfBuyViewBuyForAmount')}`;
        const excludeDates = step1.get('excludeDates');
        const buyForTitlesInputCustomClass = classNames(
            'etf-buy-step1__input etf-buy-step1__buy-for-input--titles',
            {
                hidden: buyForOption === BROKER_ETF_BUY_BUYFOR_AMOUNT
            }
        );
        const buyForAmountInputCustomClass = classNames(
            'etf-buy-step1__input etf-buy-step1__buy-for-input--amount',
            {
                hidden: buyForOption === BROKER_ETF_BUY_BUYFOR_TITLES
            }
        );

        const radioButtons = this.buildRadioButtons();
        const orderTypeInputCustomClass = classNames(
            radioButtons.length === 3
                ? 'etf-buy-step1__input etf-buy-step1__order-type-input-three-options'
                : 'etf-buy-step1__input etf-buy-step1__order-type-input-two-options',
            {
                hidden: orderTypeOption !== BROKER_ORDER_TYPE_LIMITED
            }
        );
        const buyForTitlesInput = (
            <div className={buyForTitlesInputCustomClass}>
                <InputSafe
                    type="text"
                    value={buyForValue}
                    autoComplete="off"
                    onChange={this.handleBuyForInputChange}
                    errorState={errorFlags.get('buyForValue')}
                    errorMessage={formatText('broker-etfBuyViewBuyForTitlesError')}
                />
            </div>
        );
        const buyForAmountErrorState = errorFlags.get('buyForValue')
            ? errorFlags.get('buyForValue')
            : errorFlags.get('orderTypeValueLowerThanLimit');

        const buyForAmountErrorMessage = errorFlags.get('buyForValue')
            ? formatText('broker-etfBuyViewBuyForAmountError')
            : formatText('broker-etfBuyViewBuyLowerThanLimitedImportError');
        const language = getLanguage();
        const onBuyForInputAmountChange = this.handleBuyForInputAmountChange;
        const buyForAmountInput = (
            <div className={buyForAmountInputCustomClass}>
                <AmountInput
                    min={0}
                    amount={buyForValue}
                    callback={onBuyForInputAmountChange}
                    error={buyForAmountErrorState}
                    errorMsg={buyForAmountErrorMessage}
                    language={language}
                />
            </div>
        );
        const onOrderTypeInputChange = this.handleOrderTypeInputChange;
        const orderTypeInput = (
            <div className={orderTypeInputCustomClass}>
                <AmountInput
                    min={0}
                    amount={orderTypeValue}
                    callback={onOrderTypeInputChange}
                    error={errorFlags.get('orderTypeValue')}
                    errorMsg={formatText('broker-etfBuyViewOrderTypeError')}
                    maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE_LIMITED}
                    language={language}
                />
            </div>
        );

        const contractErrorState = errorFlags.get('isETFsContractEmpty');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        let dropdownSection;

        if (this.props.immMyInvestments.get('isFetching')) {
            dropdownSection = <LoadingSection />;
        } else {
            dropdownSection = (
                <StocksContractDropdown
                    immAccounts={immAccounts}
                    immBrokerStocksContract={immStocksContracts}
                    onStockContractChange={stockContractChanged}
                    options={stocksContractDropdownOptions}
                    selectedValue={stocksContractSelectedValue}
                    placeholder={stocksContractPlaceholder}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER}
                    errorState={contractErrorState}
                    errorMessage={formatText('broker-stocksBuyStep1NoAccountError')}
                    loading={isBlockedAccountsLoading}
                />
            );
        }

        const legalSection = this.buildLegalSection();

        return (
            <div className="etf-buy-step1">
                {legalSection}
                <header className="etf-buy-step1__header">
                    <h2 className="etf-buy-step1__header-title">
                        <FormattedText value="broker-etfBuyViewStep1HeaderTitle" />
                    </h2>
                </header>

                <div className="etf-buy-step1__dropdown">
                    {dropdownSection}
                </div>

                <div className="etf-buy-step1__group-div">
                    <h2 className="etf-buy-step1__subtitle etf-buy-step1__subtitle--inline">
                        <FormattedText value="broker-etfBuyViewStep1BuyForText" />
                        <OKTooltip
                            content="broker-etfBuyViewBuyForTooltipText"
                            offset={[0, -15]}
                        />
                    </h2>

                    <RadioButtonGroup
                        selectedValue={buyForOption}
                        onChange={this.handleBuyForRadiosChange}
                        name="buyForRadioGroup"
                        idPrefix="buyForRadioGroup"
                    >
                        <RadioButton
                            label={formatText('broker-etfBuyViewBuyForTitles')}
                            value={BROKER_ETF_BUY_BUYFOR_TITLES}
                            className="etf-buy-step1__radio-button"
                        />
                        <RadioButton
                            label={buyForAmountLabel}
                            value={BROKER_ETF_BUY_BUYFOR_AMOUNT}
                            className="etf-buy-step1__radio-button"
                        />
                    </RadioButtonGroup>
                    {buyForTitlesInput}
                    {buyForAmountInput}
                </div>

                <div className="etf-buy-step1__group-div">
                    <h2 className="etf-buy-step1__subtitle etf-buy-step1__subtitle--inline">
                        <FormattedText value="broker-etfBuyViewStep1OrderTypeText" />
                        <OKTooltip
                            content="broker-etfBuyViewOrderTypeTooltipText"
                            offset={[0, -15]}
                        />
                    </h2>

                    <RadioButtonGroup
                        selectedValue={orderTypeOption}
                        onChange={this.handleOrderTypeRadiosChange}
                        name="orderTypeRadioGroup"
                        idPrefix="orderTypeRadioGroup"
                    >
                        {radioButtons}
                    </RadioButtonGroup>
                    {orderTypeInput}
                </div>

                <div className="etf-buy-step1__group-div">
                    <h2 className="etf-buy-step1__subtitle etf-buy-step1__subtitle--inline">
                        <FormattedText value="broker-etfBuyViewStep1ValidityDateLabel" />
                        <OKTooltip
                            content="broker-etfBuyViewValidityDateTooltipText"
                            offset={[0, -15]}
                        />
                    </h2>
                    <div className="etf-buy-step1__date-picker">
                        <DatePickerCustom
                            callback={this.onHandleDateChange}
                            selectedDate={validityDate}
                            newSelectedDate={validityDate}
                            maxDate={limitDate}
                            minDate={firstDate}
                            excludeDates={excludeDates}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
                <BrokerHolidayErrorModal
                    holidayErrorState={step1.getIn(['errorFlags', 'holidayError'])}
                    onSetHolidayError={this.handleHolidayModalErrorOpen}
                />
            </div>
        );
    }
}

BrokerETFBuyStep1.propTypes = {
    immBrokerWallets: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immBrokerETFBuy: PropTypes.object.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired,
    buyForOptionChanged: PropTypes.func.isRequired,
    buyForValueChanged: PropTypes.func.isRequired,
    buyForValueReset: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    orderTypeOptionChanged: PropTypes.func.isRequired,
    orderTypeValueChanged: PropTypes.func.isRequired,
    orderTypeValueReset: PropTypes.func.isRequired,
    productIsin: PropTypes.string,
    productIso: PropTypes.string.isRequired,
    productCurrency: PropTypes.string,
    productPrice: PropTypes.number,
    immMyInvestments: PropTypes.object.isRequired,
    setHolidayError: PropTypes.func.isRequired
};

module.exports.constructor = BrokerETFBuyStep1;

module.exports.BrokerETFBuyStep1 = connect(
    state => ({
        immAccounts: state.accounts,
        immBrokerWallets: state.brokerWallets,
        immBrokerETFBuy: state.brokerETFBuy,
        immStocksContracts: state.brokerStocksContract,
        immMyInvestments: state.brokerMyInvestments
    }),
    {
        getBlockedAccounts: BlockedAccounts.getBlockedAccounts,
        stockContractChanged: BrokerETFBuyActions.stockContractChanged,
        validityDateChanged: BrokerETFBuyActions.validityDateChanged,
        buyForOptionChanged: BrokerETFBuyActions.buyForOptionChanged,
        buyForValueChanged: BrokerETFBuyActions.buyForValueChanged,
        buyForValueReset: BrokerETFBuyActions.buyForValueReset,
        orderTypeOptionChanged: BrokerETFBuyActions.orderTypeOptionChanged,
        orderTypeValueChanged: BrokerETFBuyActions.orderTypeValueChanged,
        orderTypeValueReset: BrokerETFBuyActions.orderTypeValueReset,
        setHolidayError: BrokerETFBuyActions.setHolidayError
    }
)(BrokerETFBuyStep1);
